import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { validatePasswordReset } from '../../../redux/slices/authSlice';
const ValidateResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const userIdentifier = decodeURIComponent(searchParams.get('identifier'));
  const code = decodeURIComponent(searchParams.get('token'));
  console.log(userIdentifier)

  const { validateResetSuccess, validateResetError } = useSelector((state) => state.auth);
  //const userId = validateResetCode?.code
  useEffect(() => {
    if (userIdentifier && code) {
      dispatch(validatePasswordReset({ userIdentifier, code }));
    }
  }, [dispatch, userIdentifier, code]);

  useEffect(() => {
    if (validateResetSuccess) {
      navigate(`/reset-password`);
    }
    else if (validateResetError) {
      navigate(`/forgot-password`);
    }
  }, [validateResetSuccess, validateResetError, navigate]);

  return (
    <div>
    </div>
  );
};

export default ValidateResetPassword;
